module.exports = __webpack_public_path__ + "img/7f0f6aa.svg";